import { useState } from 'react';
import { copyTextToClipboard, showToast } from '../../../../utils/miscFunctions';
import ShareComponent from '../../../../components/share/ShareComponent';
import { Check, Copy, Link } from 'lucide-react';
import Tooltip from '../../../../components/ToolTip';

const PaymentLinkModal = ({
  onProceed,
  onClose,
  link,
  paymentId,
  phone
}: {
  onProceed: () => void;
  onClose: () => void;
  link: string;
  paymentId?: number;
  phone?: string;
}) => {
 const [copied, setCopied] = useState(false);
  
  const handleCopyClick = (value: string) => {
   
    setCopied(true);
    copyTextToClipboard(value)
      .then(() => {
        showToast.success('Copied to clipboard');
      })
      .catch((err) => {});
  };

  return (
    <div className='mb-3 px-4 md:px-6 py-5'>

       <div className="">
          <div className="flex rounded-lg shadow-sm overflow-hidden">
      
            <input
              type="text"
              id="share-link"
              name="share-link"
              className="flex-1 min-w-0 block w-full px-4 py-2.5 border border-gray-200 focus:outline-none text-sm rounded-l-lg"
              value={link}
              readOnly
            />
              <Tooltip
            placement="bottom"
            bgColor="bg-black"
            textColor="text-white"
            message={'Copy payment link'}>
              <div>
                <button
                  type="button"
                  onClick={()=>link && handleCopyClick(link)}
                  className="inline-flex items-center justify-center min-w-[46px] px-3 py-2.5 border  border-gray-200 bg-gray-50 text-gray-700 "
                  // aria-label={copied ? "Copied" : "Copy payment link"}
                >
                  {copied ? <Check className="h-4.5 w-4.5" /> : <Copy className="h-4.5 w-4.5" />}
                </button>
              </div>
          </Tooltip>
           
              <Tooltip
            placement="bottom"
            bgColor="bg-black"
            textColor="text-white"
            message={'Open payment link'}>
              <div>
                <button
                  className="inline-flex items-center justify-center min-w-[46px] px-3 py-2.5 border  border-gray-200 bg-gray-50 text-gray-700 rounded-r-lg"
                  onClick={()=> link && window.open(link)}
                  > 
                  <Link />
                  
                </button>
              </div>
          </Tooltip>
           
          </div>

      <div className="mt-10">
        <span className='text-sm font-medium text-gray-700 mb-3 py-3 dark:text-darkBg-mainText'>Send via</span>
        <ShareComponent title={'Payment Link'} text={link} url={link} paymentId={paymentId} phone={phone}/>
      </div>
    </div>


</div>
   
  );
};

export default PaymentLinkModal;
